import type React from "react"

export const Layout_2_2: React.FC<React.SVGAttributes<SVGSVGElement>> = (
  props,
) => (
  <svg
    width="22"
    height="27"
    viewBox="0 0 22 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Layout 2-2</title>
    <path
      d="M3.74026 4.74026C3.74026 4.18798 4.18797 3.74026 4.74026 3.74026H8.97403C9.52631 3.74026 9.97403 4.18797 9.97403 4.74026V10.8442C9.97403 11.3964 9.52631 11.8442 8.97403 11.8442H4.74026C4.18798 11.8442 3.74026 11.3964 3.74026 10.8442V4.74026Z"
      fill={props.fill ?? "#2C1789"}
    />
    <path
      d="M3.74026 15.026C3.74026 14.4737 4.18797 14.026 4.74026 14.026H8.97403C9.52631 14.026 9.97403 14.4737 9.97403 15.026V21.1299C9.97403 21.6822 9.52631 22.1299 8.97403 22.1299H4.74026C4.18798 22.1299 3.74026 21.6822 3.74026 21.1299V15.026Z"
      fill={props.fill ?? "#2C1789"}
    />
    <path
      d="M11.2208 4.74026C11.2208 4.18798 11.6685 3.74026 12.2208 3.74026H16.4545C17.0068 3.74026 17.4545 4.18797 17.4545 4.74026V10.8442C17.4545 11.3964 17.0068 11.8442 16.4545 11.8442H12.2208C11.6685 11.8442 11.2208 11.3964 11.2208 10.8442V4.74026Z"
      fill={props.fill ?? "#2C1789"}
    />
    <path
      d="M11.2208 15.026C11.2208 14.4737 11.6685 14.026 12.2208 14.026H16.4545C17.0068 14.026 17.4545 14.4737 17.4545 15.026V21.1299C17.4545 21.6822 17.0068 22.1299 16.4545 22.1299H12.2208C11.6685 22.1299 11.2208 21.6822 11.2208 21.1299V15.026Z"
      fill={props.fill ?? "#2C1789"}
    />
    <path
      d="M17.6623 0H3.53247C1.54545 0 0 1.48295 0 3.27273V22.9091C0 24.75 1.54545 26.1818 3.53247 26.1818H17.6623C19.5942 26.1818 21.1948 24.75 21.1948 22.9091V3.27273C21.1948 1.48295 19.5942 0 17.6623 0ZM19.4286 22.9091C19.4286 23.8295 18.6007 24.5455 17.6623 24.5455H3.53247C2.53896 24.5455 1.76623 23.8295 1.76623 22.9091V3.27273C1.76623 2.40341 2.53896 1.63636 3.53247 1.63636H17.6623C18.6007 1.63636 19.4286 2.40341 19.4286 3.27273V22.9091Z"
      fill={props.fill ?? "#2C1789"}
    />
  </svg>
)
